import React from 'react'
import classNames from 'classnames'

import {t} from '@lib/helpers'

const UploadForm = ({name, onChange, isLoading}) => {
  const [submitting, setSubmitting] = React.useState(false)
  const [uploadImage, setUploadImage] = React.useState(null)

  const handleChange = async (event) => {
    event.preventDefault()

    const file = event.currentTarget.files[0]

    if (!file) {
      return
    }

    setUploadImage(file)
    setSubmitting(true)
    await onChange(file)
    setSubmitting(false)
  }

  return (
    <form className='DemoDetail__upload__form'>
      <h6>{`${t('pages.demo.shared.upload_form.title')} ${name}`}</h6>

      <div className='DemoDetail__upload__frame'>
        <div className='DemoDetail__upload__imgs'>
          {uploadImage && (
            <img src={URL.createObjectURL(uploadImage)} alt='upload image' />
          )}
        </div>

        {isLoading ? (
          <div className='DemoDetail__upload__frame__container'>
            <img
              src='/images/demo/picture.png'
              srcSet='/images/demo/picture@2x.png 2x, /images/demo/picture@3x.png 3x'
              loading='lazy'
            />

            <span>{t('pages.demo.shared.upload_form.support')}</span>

            <label
              htmlFor='upload-image'
              className={classNames('DemoDetail__button', {
                'DemoDetail__button--disabled': submitting,
              })}
            >
              {submitting
                ? t('layout.loading')
                : t('pages.demo.shared.upload_form.submit')}
            </label>
          </div>
        ) : (
          <div>{t('layout.preparing')}</div>
        )}
      </div>

      <input
        type='file'
        name='upload-image'
        id='upload-image'
        onChange={handleChange}
        accept='.jpg, .jpeg, .png'
      />
    </form>
  )
}

export default UploadForm
